import React, { useEffect, useState } from 'react'
import './Quote_of_day.css'
import Bigin_day_modal from '../../common/modals/bigin-day-modal/Bigin_day_modal'
import { useDispatch, useSelector } from 'react-redux';
import { QuoteOfTheDay, SpiritualInsight } from '../../../features/admin/common/Slice';
import { IDS } from '../../../utils/IDS';
import parse from 'html-react-parser';

const Quote_of_day = () => {

  const [modalShow, setModalShow] = useState(false);

  const dispatch = useDispatch();

  const quote_of_day = useSelector((state) => state.common.quote_of_day);
  const spiritual_insights = useSelector((state) => state.common.spiritual_insights);

  useEffect(() => {
    dispatch(QuoteOfTheDay());
    dispatch(SpiritualInsight({ single: true }));
  }, [dispatch]);
  return (
    <>
      <section className='Quote_of_day_sec'>
        <div className='container'>
          <div className='quoteinner_div'>
            <div className='row'>
              <div className='col-md-5'>
                <div className='babaiamgediv'>
                  <img className='lotusbg' src={process.env.PUBLIC_URL + '/assets/images/home/quote-day/lotus.gif'} alt="lotusbg" />

                  <div className='overlay_div'>
                    <img className='babaiimg' src={process.env.PUBLIC_URL + '/assets/images/home/quote-day/maharaj.png'} alt="babaiimg" />
                  </div>
                </div>
              </div>
              <div className='col-md-7 '>
                <div className='contentdiv '>
                  <h4 className='quoteh4'>Quote of the Day</h4>
                  <div className="info_text_holder">
                    <p className='subcont'>{parse(quote_of_day?.description || " ")}</p>
                    {/* <hr className='underline'></hr>
                    <p className="subcont">
                      The life force pervading the universe is the Supreme.
                      All elements—sky, air, water, fire, and earth—hold this divine presence.
                      Every atom of our body contains the same eternal energy.
                      This vital force sustains and guides all creation.
                      The Supreme exists within us and all around us.
                    </p> */}
                  </div>
                </div>
                {/* <div className='contentdiv'>
                  <h4 className='quoteh4'>Quote of the Day</h4>
                  <div className="info_text_holder">
                    <p className='subcont'>इस समस्त ब्रह्माण्ड में व्याप्त जो प्राण है, वही परमात्मा का स्वरूप है।
                      हम जिस आकाश, वायु, जल, अग्नि और पृथ्वी को अनुभव करते हैं, उनमें भी वही परम चेतना विद्यमान है।
                      हमारे शरीर के प्रत्येक अणु–अणु में वही दिव्य प्राण शक्ति सजीव होकर कार्य कर रही है।
                      यह प्राण ही जीवन का आधार है और इसी से सृष्टि की प्रत्येक गति संचालित होती है।
                      अतः वास्तव में परमात्मा कहीं बाहर नहीं, बल्कि हमारे भीतर और चारों ओर व्याप्त है।</p>
                    <hr className='underline'></hr>
                    <p className="subcont">
                      The life force pervading the universe is the Supreme.
                      All elements—sky, air, water, fire, and earth—hold this divine presence.
                      Every atom of our body contains the same eternal energy.
                      This vital force sustains and guides all creation.
                      The Supreme exists within us and all around us.
                    </p>
                  </div>
                </div> */}
              </div>
            </div>

            <div className='begindiv'>
              <div className='beginbtndiv'>
                <div className='row'>
                  <div className='col-md-5 my-auto'>
                    <h6 className='dnyanh6'>Dhyanyogi SHREE NARAYAN SWAMI</h6>
                  </div>
                  <div className='col-md-7  my-auto text-md-end text-center'>
                    <button type='button' onClick={() => setModalShow(true)} className='beginbtn zoom_in_out'><img className='playicn ' src={process.env.PUBLIC_URL + '/assets/images/home/quote-day/play.png'} alt="playicon" />Begin Day with Gurudev</button>
                  </div>
                </div>
              </div>

              <div className='quotdiv'>
                <img className='quoteicon' src={process.env.PUBLIC_URL + '/assets/images/home/quote-day/quoteicon.png'} alt="quoteicon" />
              </div>

            </div>
          </div>
        </div>

        <Bigin_day_modal
          image={IDS.IMG_URL + spiritual_insights?.image}
          show={modalShow}
          onHide={() => setModalShow(false)}
        />
      </section>
    </>
  )
}

export default Quote_of_day